/** @module Sourcing/MassAbandonSupplierItems */
define([
	"dojo/_base/declare",
	"./MassActionSupplierItems"
], function(declare,MassActionSupplierItems) {

	return declare(MassActionSupplierItems, {
		/**
		 * @override
		 * Return list of modified Master URLs used by PostAction
		 */
		getModifiedUrls: function() {
			const modifiedUrls = this.inherited(arguments);
			const cache = this.m_cache;
			//fetch master url from modifiedUrls
			return modifiedUrls && modifiedUrls.map((url) => cache.get(url).Master);
		}
	});
});
